// removed by extract-text-webpack-plugin
module.exports = {"container":"YbahY","wrapper":"ptKpa","icon":"_3rKyv"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commenting-disabled/commenting-disabled.scss
// module id = 1681
// module chunks = 0